import { HashLink } from 'react-router-hash-link';
import styled, { css } from 'styled-components';

export const baseLinkStyles = css`
  font-weight: var(--semi-bold);
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s ease;
  color: var(--link);
  background: transparent;
  border: none;
  &:hover {
    color: var(--link-hover);
  }

  &[disabled] {
    color: var(--link-disabled);
    pointer-events: none;
  }
`;

export default styled(HashLink)`
  ${baseLinkStyles}
`;
